import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

declare var $: any;

@Injectable()
export class ExportExcelService {
  nomeModulo: string;
  rows: number;
  formatType: string;
  colunasFormatacao: number[];

  constructor() { }
  public ExportTOExcel() {
    this.ExportTOExcelId('excel-table');
  }

  public ExportTOExcelId(idTabela: string) {
    // Manipular valores HTML, DOM,
    let htmlTabela: String = document.getElementById(idTabela).outerHTML;

    let element = $(htmlTabela);
    let colunas = $(element).find('.percentual');

    colunas.toArray().forEach(e => { $(e).text($(e).text().replace(',', '.').replace('%', '')); });
   
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element[0], {raw:true});
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Página 1');

    XLSX.writeFile(wb, 'modulo ' + this.nomeModulo + '.xlsx');
  }

  public ExportCSV(idTabela: string) {
    // Manipular valores HTML, DOM,
    let htmlTabela: String = document.getElementById(idTabela).outerHTML;

    let element = $(htmlTabela);
    let colunas = $(element).find('.percentual');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element[0], {raw:true});
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'test');
  
    XLSX.writeFile(wb, 'modulo ' + this.nomeModulo + '.csv');
  }

  public exportToCsv(rows: object[], fileName: string, columns?: string[], headers?: string[]): string {
    
    const CSV_EXTENSION = '.csv';
    const CSV_TYPE = 'text/plain;charset=utf-8';
  
    if (!rows || !rows.length) {

      return;
    }

    const separator = ';';
    const allKeys = Array.from(new Set(
      rows.flatMap(row => Object.keys(row))
    ));

    const keys = columns?.length
      ? columns.filter(k => allKeys.includes(k))
      : allKeys;
    const headerLine = (headers && headers.length === keys.length) ? headers.join(separator) : keys.join(separator);
    const csvContent =
      headerLine +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE);
  }

  private saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const data: Blob = new Blob([buffer], { type: fileType });
    FileSaver.saveAs(data, fileName);
  }

  public ExportTOExcelJSON(dados: any[]) {
    // Manipular valores HTML, DOM,
   
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dados, {header: [], skipHeader: false});

    this.autofitColumns(dados, ws);

    if ((this.colunasFormatacao != null || this.colunasFormatacao != undefined) && this.formatType != "") {
      for (let col of this.colunasFormatacao) {
        this.formatarCelulas(ws, col, this.formatType);
      }
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Página 1');

    XLSX.writeFile(wb, 'modulo ' + this.nomeModulo + '.xlsx');
  }

  private formatarCelulas(worksheet: XLSX.WorkSheet, col: number, fmt: string) {
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    for (let row = range.s.r + 1; row <= range.e.r; ++row) {
      const ref = XLSX.utils.encode_cell({ r: row, c: col });
      if (worksheet[ref] && worksheet[ref].t === 'n') {
        worksheet[ref].z = fmt;
      }
    }
  }

  private autofitColumns(json: any[], worksheet: XLSX.WorkSheet, header?: string[]) {
    const jsonKeys = header ? header : Object.keys(json[0]);

    let objectMaxLength = [];
    for (let i = 0; i < json.length; i++) {
      let value = json[i];
      for (let j = 0; j < jsonKeys.length; j++) {
        if (typeof value[jsonKeys[j]] == "number") {
          objectMaxLength[j] = 10;
        } else {
          const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

          objectMaxLength[j] =
            objectMaxLength[j] >= l
              ? objectMaxLength[j]
              : l;
        }
      }

      let key = jsonKeys;
      for (let j = 0; j < key.length; j++) {
        objectMaxLength[j] =
          objectMaxLength[j] >= key[j].length
            ? objectMaxLength[j]
            : key[j].length;
      }
    }

    const wscols = objectMaxLength.map(w => { return { width: w } });
    worksheet["!cols"] = wscols;
  }
  
}
